import React, { useState } from "react";
import classes from "./Drawer.module.css";
import { useNavigate } from "react-router-dom";

const Drawer = ({ drawer, setDrawer ,setOpen}) => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setDrawer(false);
  };

  return (
    <div
      className={`${classes.drawer} ${drawer && classes.show}`}
      onClick={() => setDrawer(false)}
    >
      <div
        className={classes.drawer_container}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={classes.menu_items}>
          <button className={classes.menu_item} onClick={() => scrollToSection('top-games')}>
            Top Games
          </button>
          <div className={classes.divider}></div>

          <button className={classes.menu_item} onClick={() => scrollToSection('game-categories')}>
            Game Categories
          </button>

          <div className={classes.divider}></div>

          <button className={classes.menu_item} style={{ background: "red" }} onClick={() => {
            setDrawer(false)
            setOpen(true)
          }}>
            Unsubscribe
          </button>

        </div>
      </div>

    </div>
  );
};

export default Drawer;